var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#979592;stroke-miterlimit:10;}\n\t.st1{fill:#979592;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.2,13.9c0-2.2,0-4.3,0-6.5c0-0.8,0.5-1.4,1.3-1.5s1.6,0.5,1.6,1.4c0,0.1,0,0.2,0,0.4c0,4.2,0,8.5,0,12.7 c0,0.7-0.3,1.2-0.9,1.4c-1,0.4-2-0.3-2-1.4s0-2.3,0-3.4C18.2,16,18.2,14.9,18.2,13.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,15.8c0-1.5,0-3,0-4.5c0-0.8,0.6-1.5,1.4-1.5c0.8,0,1.5,0.6,1.5,1.5c0,3,0,6,0,9.1c0,0.9-0.6,1.5-1.4,1.5 c-0.8,0-1.4-0.7-1.4-1.5C8,18.9,8,17.4,8,15.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.9,17.4c0-1,0-2,0-3c0-0.6,0.4-1.1,1-1.3s1.2,0,1.6,0.4c0.2,0.3,0.3,0.6,0.3,0.9c0,2,0,4.1,0,6.1 c0,0.8-0.7,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4C2.9,19.4,2.9,18.4,2.9,17.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,17.4c0,1,0,2,0,3c0,0.7-0.5,1.3-1.1,1.4c-0.6,0.2-1.3-0.1-1.6-0.7c-0.1-0.2-0.2-0.4-0.2-0.7c0-2,0-4,0-6 c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C16,15.4,16,16.4,16,17.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,6.5c0-0.5,0.4-1,0.9-1s1,0.4,1,0.9c0,0.1,0,0.2,0.2,0.3c1.1,0.7,2.2,1.3,3.3,2c0.1,0.1,0.2,0.1,0.3,0 c0.2-0.1,0.4-0.1,0.5-0.1s0.2,0,0.2-0.1c1.3-1.8,2.6-3.6,3.9-5.4c0.1-0.1,0.1-0.1,0-0.2c-0.2-0.4-0.1-0.8,0.2-1.1 c0.3-0.3,0.8-0.3,1.1-0.1c0.4,0.2,0.5,0.6,0.5,1c-0.1,0.4-0.4,0.8-0.9,0.7c-0.3,0-0.4,0.2-0.6,0.3C18,5.6,16.7,7.3,15.5,9 c-0.1,0.1-0.1,0.2,0,0.3c0.2,0.4,0.1,0.8-0.2,1c-0.3,0.3-0.7,0.4-1,0.2c-0.4-0.1-0.6-0.5-0.6-0.9c0-0.1,0-0.2-0.1-0.3 c-1.1-0.7-2.2-1.3-3.3-2c-0.1-0.1-0.1-0.1-0.2,0C9.6,7.5,9.3,7.5,9,7.3c-0.1-0.1-0.2,0-0.3,0c-1,0.7-2.1,1.4-3.2,2 C5.4,9.4,5.3,9.5,5.3,9.6c0,0.5-0.4,0.9-0.9,0.9c-0.5,0.1-0.9-0.3-1-0.7C3.3,9.3,3.6,8.8,4,8.7c0.3-0.1,0.5-0.1,0.8,0.1 c0.1,0.1,0.2,0.1,0.3,0c1.1-0.7,2.2-1.4,3.3-2C8.5,6.7,8.6,6.6,8.5,6.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analyticsIcon.c0f0945c941a4fa4c9e332f0f63ff62f.svg";
export { ForwardRef as ReactComponent };